module.exports = __webpack_public_path__ + "static/fonts/DS-DIGII.8e8e625f.TTF";